import { BACS_REMOVE_PAYMENT, INITIALISE_BACS_CREDIT } from '../bacsCredit/actions';
import { INIT_VALIDATION, INIT_VALIDATION_FOR_TEMPLATE, INIT_BACS_VALIDATION } from './actions';
import { BACSDEBIT_REMOVE_PAYMENT, INITIALISE_BACS_DEBIT } from '../bacsDebit/actions';
import { initialState } from './common';
import { RESET_APP } from '../page/actions';

const defaultRowState = {
	amount: { ...initialState },
};

export const defaultState = {
	from: {
		bacsId: { ...initialState },
	},
};
const removePayment = (state, action) => {
	const { [action.id]: keyToDelete, ...newState } = state;
	return newState;
};

export const BacsHandlers = {
	[INIT_BACS_VALIDATION]: (state) => ({ ...defaultState, paymentType: state.paymentType }),
	[INIT_VALIDATION]: (state, action) => ({
		...state,
		[action.id]: { ...defaultRowState },
		paymentType: state.paymentType,
	}),
	[INIT_VALIDATION_FOR_TEMPLATE]: (state) => ({
		from: {},
		paymentType: state.paymentType,
		'template-name': { name: { ...initialState, isValid: true } },
	}),
	[BACS_REMOVE_PAYMENT]: removePayment,
	[BACSDEBIT_REMOVE_PAYMENT]: removePayment,
	[INITIALISE_BACS_CREDIT]: (state) => ({ ...defaultState, paymentType: state.paymentType }),
	[INITIALISE_BACS_DEBIT]: (state) => ({ ...defaultState, paymentType: state.paymentType }),
	[RESET_APP]: (state) => ({ ...defaultState, paymentType: state.paymentType }),
};
